import { render, staticRenderFns } from "./luckyTurntable.vue?vue&type=template&id=3f51654b"
import script from "./luckyTurntable.vue?vue&type=script&lang=js"
export * from "./luckyTurntable.vue?vue&type=script&lang=js"
import style0 from "./luckyTurntable.vue?vue&type=style&index=0&id=3f51654b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports